// extracted by mini-css-extract-plugin
module.exports = {"control":"CarsCheckoutComplete_control__1J0Qe","row":"CarsCheckoutComplete_row__1qjzt","col":"CarsCheckoutComplete_col__QgxKs"};